import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ArtificialIntelligenceEnhancedIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "ArtificialIntelligenceEnhanced",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "m20.47 12.37-1.69 3.09a7.97 7.97 0 0 1-3.14 3.14l-3.09 1.69c-.49.27-.49.97 0 1.23l3.09 1.68c1.33.73 2.42 1.82 3.15 3.15l1.69 3.09c.27.49.97.49 1.23 0l1.69-3.09a7.97 7.97 0 0 1 3.14-3.14l3.09-1.69c.49-.27.49-.97 0-1.23l-3.09-1.69a7.97 7.97 0 0 1-3.14-3.14l-1.69-3.09a.698.698 0 0 0-1.23 0ZM8 2.46 6.78 4.69c-.52.96-1.31 1.76-2.28 2.28L2.27 8.19c-.35.2-.35.7 0 .9l2.23 1.22c.96.52 1.76 1.31 2.28 2.28L8 14.82c.2.35.7.35.9 0l1.22-2.24c.52-.96 1.31-1.76 2.28-2.28l2.23-1.22c.35-.2.35-.7 0-.9L12.4 6.96a5.63 5.63 0 0 1-2.28-2.28L8.9 2.45c-.2-.35-.7-.35-.9 0Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M12.14 20.14c4.42 0 8-3.58 8-8 0 4.42 3.58 8 8 8-4.42 0-8 3.58-8 8 0-4.42-3.58-8-8-8"
      }), /*#__PURE__*/_jsx("path", {
        d: "M20.14 29.28c-.63 0-1.14-.51-1.14-1.14 0-3.78-3.08-6.86-6.86-6.86a1.14 1.14 0 1 1 0-2.28c3.78 0 6.86-3.08 6.86-6.86a1.14 1.14 0 1 1 2.28 0c0 3.78 3.08 6.86 6.86 6.86a1.14 1.14 0 1 1 0 2.28c-3.78 0-6.86 3.08-6.86 6.86 0 .63-.51 1.14-1.14 1.14m-3.57-9.14c1.5.83 2.74 2.08 3.58 3.58.83-1.5 2.08-2.74 3.58-3.58a9.26 9.26 0 0 1-3.58-3.58 9.26 9.26 0 0 1-3.58 3.58M3 8.71c3.16 0 5.71 2.56 5.71 5.71 0-3.16 2.56-5.71 5.71-5.71-3.16 0-5.71-2.56-5.71-5.71 0 3.16-2.56 5.71-5.71 5.71"
      }), /*#__PURE__*/_jsx("path", {
        d: "M8.71 15.57c-.63 0-1.14-.51-1.14-1.14 0-2.52-2.05-4.57-4.57-4.57a1.14 1.14 0 1 1 0-2.28c2.52 0 4.57-2.05 4.57-4.57a1.14 1.14 0 1 1 2.28 0c0 2.52 2.05 4.57 4.57 4.57a1.14 1.14 0 1 1 0 2.28c-2.52 0-4.57 2.05-4.57 4.57 0 .63-.51 1.14-1.14 1.14M6.79 8.71c.76.51 1.42 1.16 1.93 1.93.51-.76 1.16-1.42 1.93-1.93a7 7 0 0 1-1.93-1.93c-.51.76-1.16 1.42-1.93 1.93"
      })]
    })
  }));
};
ArtificialIntelligenceEnhancedIcon.displayName = 'ArtificialIntelligenceEnhancedIcon';